export const CONSENT_LINK_SCOPES = {
    CONSENT_READ: "consent:read",
    CONSENT_SUBMIT: "consent:submit",
    PAYMENT_CARD_STATUS: "payment_card:status",
    PAYMENT_CARD_ADD: "payment_card:add",
} as const;
